import {UserResponse} from "../../core/models/user";
import {Receipt} from "../receipt/receiptModel";

export type SplitPreference = 'equal' | 'items';

export interface GroupGuest {
  id: number;
  name: string;
}

export interface Group {
  id?: number;
  ownerId?: number;
  invitations?: {id: number; user: UserResponse; status: 'PENDING' | 'ACCEPTED' | 'DECLINED'}[];
  name: string;
  users: UserResponse [];
  guests?: GroupGuest[];
  receipts?: Receipt[];
  splitPreference?: SplitPreference;
  imageGroup?: string | null;
}

export interface CreateGroupRequest {
  name: string;
  users: string [];
  splitPreference: SplitPreference;
  groupImage?: File;
}

export const groupKey = (group: Group) => group.id ? `id:${group.id}` : group.name;
export const allocationMembers = (group: Group) => [...group.users, ...(group.invitations ?? []).filter(invite => invite.status === 'PENDING').map(invite => invite.user)];
